<template>
    <ul v-if="child?.children?.length > 0" class="pl-4 py-2">
        <li v-for="subChildEntry in child.children" :key="subChildEntry.id">
            <template
                v-if="subChildEntry.customFields?.custom_category_flyout_section !== 'is_top_brand'
                    && subChildEntry.customFields?.custom_category_flyout_section !== 'is_highlight'
                    && subChildEntry.customFields?.custom_category_flyout_section !== 'is_new_sale'"
            >
                <MiscLink
                    no-prefetch
                    :to="formatLink(getCategoryRoute(subChildEntry))"
                    class="navigation-item-link block py-1"
                    :class="{'active' : isRouteActive(subChildEntry)}"
                >
                    <span class="text-xs brand-page-color-active:text-brand-page-color" :class="{'font-semibold text-base-content-subtle' : !level, 'text-primary': level}">{{ getTranslatedProperty(subChildEntry, 'name') }}</span>
                </MiscLink>

                <LayoutNavigationSidebarSubcategory v-if="isRouteActive(subChildEntry)" :child="subChildEntry" :level="true" />
            </template>
        </li>
    </ul>
</template>

<script setup lang="ts">
import type { Schemas } from '#shopware'
import { getCategoryRoute, getTranslatedProperty } from '@shopware/helpers'

interface Props {
    child: Schemas['Category'],
    level?: boolean
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
    level: true
})

const route = useRoute()
const localePath = useLocalePath()
const { formatLink } = useInternationalization(localePath)

function isRouteActive(item: Schemas['Category']) {
    return isCategoryRouteActive(route.path, item)
}
</script>
